import { useEffect, useRef, useState } from 'react';

export function useDebouncedFilterValue(
    value: string,
    onDebouncedChange: (value: string) => void,
    delayMs = 300
) {
    const [draftValue, setDraftValue] = useState(value);
    const onDebouncedChangeRef = useRef(onDebouncedChange);

    useEffect(() => {
        onDebouncedChangeRef.current = onDebouncedChange;
    }, [onDebouncedChange]);

    useEffect(() => {
        setDraftValue(value);
    }, [value]);

    useEffect(() => {
        if (draftValue === value) return;
        const timer = window.setTimeout(() => {
            onDebouncedChangeRef.current(draftValue);
        }, delayMs);
        return () => window.clearTimeout(timer);
    }, [delayMs, draftValue, value]);

    return [draftValue, setDraftValue] as const;
}
